import { CombinationsStep } from '@/pages/pii-training/CombinationsStep';
import { ConsentStep } from '@/pages/pii-training/ConsentStep';
import { QuizStep } from '@/pages/pii-training/QuizStep';
import { WhatIsPiiStep } from '@/pages/pii-training/WhatIsPiiStep';
import type { PiiTrainingStepBodyProps } from '@/pages/pii-training/piiTraining.types';

export const PiiTrainingStepBody = ({ step, copy, control }: PiiTrainingStepBodyProps) => {
  switch (step) {
    case 1:
      return <WhatIsPiiStep copy={copy} />;
    case 2:
      return <CombinationsStep copy={copy} />;
    case 3:
      return <QuizStep copy={copy} control={control} />;
    default:
      return <ConsentStep copy={copy} control={control} />;
  }
};
